import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { format, isValid, parseISO } from "date-fns";
import { jsonLogic } from "@reside/forms";
import { DATE_FORMAT } from "../../date-picker/date";
import { prop } from "../template";
import { Text } from "../../text";
export const DateRenderer = ({ values, value, format: dateFormat = DATE_FORMAT.FULL_DATE, }) => {
    try {
        const date = parseISO(prop(values, value, value));
        const parsed = isValid(date)
            ? date
            : jsonLogic.apply(JSON.parse(value.replace(/`/gi, "")), values);
        // The `` is a work-around, without it, the value would be passed as object and broken into different properties
        // or as invalid string
        return (_jsx("span", { children: isValid(parsed)
                ? format(parsed, dateFormat)
                : "ERR_INVALID_DATE_LOGIC" }));
    }
    catch {
        return _jsxs(Text, { color: "deepOrange100", children: ["ERR_INVALID_DATE_VALUE - ", value] });
    }
};
